import { TextField } from "@mui/material";

const RoundedTextField = ({ placeholder = "", value, onChange, ...props }) => {
  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      InputProps={{
        sx: {
          //border: '1px solid #2A4876',
          borderRadius: "50px", // Rounded corners
          backgroundColor: "#F2F7FB", // Light background color
          padding: "10px 15px", // Inner padding for better alignment
          "& fieldset": {
            border: "none", // Subtle border
          },
          "&:hover fieldset": {
            border: "none", // Darker border on hover
          },
          "&.Mui-focused fieldset": {
            border: "none", // Highlighted border on focus
          },
        },
      }}
      {...props} // Allow passing additional props
    />
  );
};

export default RoundedTextField;
